export const forbiddenWords = [
  '--',
  '|'
];
